/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
import { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";


import { Header } from "./Header";
import { MessageList } from "./MessageList";
import { MessageInput } from "./MessageInput";
import { AppState } from "../store/definitions";
import { ConversationEnded } from "./ConversationEnded";
import { ConversationUserEnded } from "./ConversationUserEnded";
import { NotificationBar } from "./NotificationBar";
import { removeNotification } from "../store/actions/genericActions";
import { notifications } from "../notifications";
import { AttachFileDropArea } from "./AttachFileDropArea";

export const MessagingCanvasPhase = () => {
    const dispatch = useDispatch();
    const {conversationState, currentPhase} = useSelector((state: AppState) => ({
        conversationState: state.chat.conversationState,
        currentPhase: state.session.currentPhase
}));

    useEffect(() => {
        dispatch(removeNotification(notifications.failedToInitSessionNotification("ds").id));
    }, [dispatch]);

    const Wrapper = conversationState === "active" ? AttachFileDropArea : Fragment;

    return (
        <Wrapper>
            <Header />
            <NotificationBar />
            <MessageList />
            {currentPhase==="UserEnding" ? <ConversationUserEnded/> : (conversationState === "active" ?  <MessageInput /> : <ConversationEnded />)}
           
        </Wrapper>
    );
};
